<template>
  <input
    ref="file-input"
    type="file"
    :accept="accept"
    @change.prevent="handleInputFiles($refs['file-input'].files)"
  />
</template>

<script>
export default {
  props: {
    accept: {
      type: String,
      default: "*"
    }
  },

  methods: {
    handleInputFiles(files) {
      if (files.length <= 0) return;

      const file = files[0];

      this.$refs["file-input"].value = "";

      this.$emit("input", file);
    }
  }
};
</script>
